ThemeJS.Tooltips = ( function ( $ ) {

  // enable BS tooltips globally

  function init () {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach( el => {
      const existing = bootstrap.Tooltip.getInstance(el)
      if (existing) existing.dispose()

      const tooltip = new bootstrap.Tooltip( el, {
        html: true,
        sanitize: false,
        trigger: 'hover click',
        title: () => {
          const template = el.querySelector('template')
          return template
            ? template.innerHTML
            : el.getAttribute('title')
        }
      })

      el.addEventListener('blur', () => {
        tooltip.hide();
      });
    });
  }

  document.addEventListener( 'DOMContentLoaded', init );
  jQuery( document.body ).on( 'updated_checkout updated_cart_totals', init )

  return { init }

})( jQuery );